import {Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {PlanningUpdate, PlanningUpdateParty} from "@portbase/bezoekschip-service-typescriptmodels";
import moment from "moment/moment";

@Component({
  selector: 'app-planning-history',
  templateUrl: './planning-history.component.html',
  styleUrls: ['./planning-history.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PlanningHistoryComponent implements OnInit, OnChanges {

  @Input() movementSpecifiers: string[];
  @Input() planningHistory: PlanningUpdate[];
  @Input() declaredDate: string;
  @Input() originallyDeclaredDate: string;

  originallyDeclaredTime: string
  proposedTimeAndGapArray: string[] = [];
  totalShiftDuration: string;

  ngOnInit() {
    this.initTimes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initTimes();
  }

  initTimes() {

    this.proposedTimeAndGapArray = [];

    const originallyDeclaredDate = new Date(this.originallyDeclaredDate);
    this.originallyDeclaredTime = this.getTime(originallyDeclaredDate);

    // Sort the planning history in asc order
    this.sortPlanningHistory(true);
    let previousDate: Date = null;

    if (!!this.planningHistory) {
      this.planningHistory.forEach(planningUpdate => {
          const proposedDate = new Date(planningUpdate.proposedTime);
          let diffString: string;

          if (!previousDate) {
            diffString = this.getDiffString(proposedDate, originallyDeclaredDate);
          } else {
            diffString = this.getDiffString(proposedDate, previousDate);
          }

          previousDate = proposedDate;

          this.proposedTimeAndGapArray.push(`${this.getTime(proposedDate)} (${diffString})`);
        }
      );
    }

    // Sort the planning history in desc order
    this.sortPlanningHistory(false);

    this.proposedTimeAndGapArray.reverse();
    this.proposedTimeAndGapArray.push(`${this.getTime(new Date(this.originallyDeclaredDate))}`);

    const latestPlanningUpdate = !this.planningHistory ? null : this.planningHistory[0];

    if (latestPlanningUpdate) {
      this.totalShiftDuration = this.getDiffString(new Date(latestPlanningUpdate.proposedTime), originallyDeclaredDate);
    }
  }

  sortPlanningHistory(ascending: boolean) {
    if (!!this.planningHistory) {
      this.planningHistory.sort((a, b) => {
        const timestampA = a.timestamp ? new Date(a.timestamp).getTime() : -Infinity;
        const timestampB = b.timestamp ? new Date(b.timestamp).getTime() : -Infinity;
        if (ascending) {
          return timestampA - timestampB;
        } else {
          return timestampB - timestampA;
        }
      });
    }
  }

  getDiffString(nextDate: any, previousDate: any): string {
    let diffMilliseconds = nextDate.getTime() - previousDate.getTime();
    const sign = diffMilliseconds >= 0 ? '+' : '-';
    const totalMinutes = Math.floor(Math.abs(diffMilliseconds) / (1000 * 60));
    const diffHours = Math.floor(totalMinutes / 60);
    const diffMinutes = totalMinutes % 60;

    return this.getShiftDuration(sign, diffHours, diffMinutes);
  }

  getTime(date: Date): string {
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');

    return `${hour}:${minute}`;
  }

  getShiftDuration(sign: string, diffHours: number, diffMinutes: number): string {
    return `${sign}${diffHours.toString().padStart(2, '0')}:${diffMinutes.toString().padStart(2, '0')}`;
  }

  displayPlanningHistory(): boolean {
    return (this.planningHistory?.length > 0 &&
            this.declaredDate != null &&
            this.originallyDeclaredDate != null) &&
           moment(this.declaredDate).isSame(this.planningHistory[0].proposedTime);
  }

  getSource(source: PlanningUpdateParty): string {
    switch (source) {
      case "HARBOUR_MASTER":
        return 'Harbour Master';
      case "TUG":
        return 'Tug';
      case "LINESMAN":
        return 'Linesman';
      case "PILOT":
        return 'Pilot';
    }
  };

  showDebugInfo(): boolean {
    return localStorage.getItem('debug-planning-history') == 'true';
  }
}
